export default __webpack_public_path__ + "static/media/approved.23492415.svg";